module.exports = __webpack_public_path__ + "static/expense_c.843e3407.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/expense_c.png
// module id = 440
// module chunks = 213720915766396